import React from "react";
import {BankAccount, BankAccountRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormToggle from "../../../../components/form/form_inputs/form_toggle";
import FormAutocomplete from "../../../../components/form/form_inputs/form_autocomplete";
import {types} from "../../../../components/form/types";

export const BankAccountEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(BankAccountRestControllerApiFactory);

    const form = useForm({
        fetcher: (id) => ctrl.getBankAccount(id),
        updater: (bean) => ctrl.saveBankAccount(bean),
        remover: (id) => ctrl.deleteOrDismissBankAccount(id),
        factory: () => ({active: true} as BankAccount),
    } as UseFormProps<BankAccount>);

    return (
        <FormContent form={form} title={"Cuenta bancaria"}>
            <Grid container spacing={3}>
                <Grid item sm={8}>
                    <FormInput field={"name"} label={"Nombre"}/>
                </Grid>
                <Grid item sm={4}>
                    <FormToggle field={"active"} label={"Activa"}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item sm={8}>
                    <FormInput field={"iban"} label={"IBAN"}/>
                </Grid>
                <Grid item sm={4}>
                    <FormInput field={"bankName"} label={"Entidad bancaria"}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item sm={4}>
                    <FormInput field={"swift"} label={"SWIFT / BIC"}/>
                </Grid>
                <Grid item sm={8}>
                    <FormToggle field={"mainAccount"}
                                label={"Cuenta de cobro (se imprime en las facturas)"}/>
                </Grid>
            </Grid>

            <FormAutocomplete
                field={"accountingAccount"}
                label={"Cuenta contable (572...)"}
                type={types.accountingAccounts}
            />
        </FormContent>
    );
};
